import CDNImage from '@/components/cdnImage/cdnImage';
import { useTranslation } from '@/i18n/client';
import { DialogContent } from '@mui/material';
import styles from './deliveryDialog.module.scss';
import UKDrawer from '@/components/UKDrawer';
import { type fulfillmentMethodListProps } from '@/apis/dp/floor.interface';

export default function ChooseDelivery(props: any) {
  const {
    openDialog,
    setOpenDialog,
    mainTitle,
    fulfillmentMethodList,
    shipmentType,
    handleSelectedDelivery,
    openCheckout,
  } = props;

  const { t } = useTranslation();

  return (
    <UKDrawer
      width={616}
      openDrawer={openDialog}
      handleClose={() => {
        setOpenDialog(false);
      }}
      showCloseButton={true}
      showTitle={true}
      title={mainTitle}
    >
      {/* <DialogTitle>{mainTitle}</DialogTitle> */}
      <DialogContent>
        <div className={styles.choose_wrap}>
          {fulfillmentMethodList?.length > 0 &&
            fulfillmentMethodList.map((item: fulfillmentMethodListProps) => {
              return (
                <div
                  className={`${styles.choose_option} ${
                    shipmentType === item.shipmentType ? styles.active : ''
                  }`}
                  onClick={() => handleSelectedDelivery(item.shipmentType)}
                  key={item.shipmentType}
                >
                  <div className={styles.choose_item}>
                    <CDNImage
                      className={styles.choose_icon}
                      src={item.icon}
                      width={32}
                      height={32}
                      alt={item.title}
                    />
                    <div
                      className={styles.choose_text}
                      dangerouslySetInnerHTML={{ __html: item.title }}
                    ></div>
                    <div
                      className={styles.choose_content}
                      dangerouslySetInnerHTML={{ __html: item.deliveryTime! }}
                    ></div>
                  </div>
                  <div
                    className={styles.choose_price}
                    dangerouslySetInnerHTML={{ __html: item.priceIntergation! }}
                  ></div>
                </div>
              );
            })}
        </div>
        <div className={styles.choose_btn_wrap}>
          <div className={styles.choose_btn} onClick={openCheckout}>
            {t('dp.buyNow')}
          </div>
        </div>
      </DialogContent>
    </UKDrawer>
  );
}
